import { useState, useEffect } from "react";

function getWindowPageOffsets() {
  const { pageXOffset: xOffset, pageYOffset: yOffset } = window;

  return {
    xOffset,
    yOffset,
  };
}

export function useWindowPageOffset() {
  const [windowPageOffsets, setWindowPageOffsets] = useState(
    getWindowPageOffsets()
  );

  useEffect(() => {
    function handleScroll() {
      setWindowPageOffsets(getWindowPageOffsets());
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return windowPageOffsets;
}
